import { createFileRoute } from "@tanstack/react-router";
import { Send } from "lucide-react";
import { PageHeader } from "@/components/page-header";
import { StatusBadge } from "@/components/status-badge";
import { Button } from "@/components/ui/button";
import { NewContractDialog } from "@/components/forms/new-contract-dialog";
import { contracts, fmtUsd } from "@/mocks/data";

export const Route = createFileRoute("/contracts")({
  head: () => ({
    meta: [
      { title: "Contracts — Studio OS" },
      { name: "description", content: "Contracts, proposals, and e-signature status." },
    ],
  }),
  component: ContractsPage,
});

function ContractsPage() {
  return (
    <div className="mx-auto max-w-7xl px-6 py-8 lg:px-10 lg:py-10">
      <PageHeader
        title="Contracts"
        description="Drafted, sent, and signed agreements."
        actions={<NewContractDialog />}
      />
      <div className="overflow-hidden rounded-xl bg-card ring-1 ring-border">
        <table className="w-full text-left text-sm">
          <thead className="border-b border-border bg-surface-muted/50">
            <tr className="text-[11px] uppercase tracking-wider text-muted-foreground">
              <th className="px-4 py-3 font-medium">Title</th>
              <th className="px-4 py-3 font-medium">Client</th>
              <th className="px-4 py-3 font-medium">Sent</th>
              <th className="px-4 py-3 font-medium">Value</th>
              <th className="px-4 py-3 font-medium">Status</th>
              <th className="px-4 py-3 text-right font-medium">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {contracts.map((c) => (
              <tr key={c.id} className="transition hover:bg-surface-muted/40">
                <td className="px-4 py-3 font-medium">{c.title}</td>
                <td className="px-4 py-3 text-muted-foreground">{c.client}</td>
                <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{c.sent}</td>
                <td className="px-4 py-3 font-mono">{fmtUsd(c.value)}</td>
                <td className="px-4 py-3"><StatusBadge status={c.status} /></td>
                <td className="px-4 py-3 text-right">
                  <Button size="sm" variant="ghost" className="h-7 gap-1.5 text-xs">
                    <Send className="size-3" /> {c.status === "draft" ? "Send" : "Resend"}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
